import { usePath } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { SortOption, Topics } from '../../components/ConversationSubjects/Topics';
import { Features, UserQuery } from '../../generated/hooks';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { isPulserTopicGroup } from '../../lib/helpers/pulser';

interface IProps {
  user: UserQuery['user'];
}

const PulserConversationSubjectsScreen: FC<IProps> = ({ user }) => {
  const { t } = useTranslation('surveysOverview');
  const { createSurveyPath, pulserSurveysPath } = usePath();
  const hasPulserModule = useFeatureFlag(Features.PulserModule);

  if (!hasPulserModule) {
    return <Redirect to="/conversationSubjects" />;
  }

  return (
    <Topics
      breadcrumbItems={[{ title: t('AuthorizedPage:pulser'), link: pulserSurveysPath.createPath() }]}
      heading={t('chooseSurveyTopic')}
      dataIcom="heading-pulser-conversation-subjects"
      user={user}
      hideCreateTopicButton={true}
      defaultSortOption={SortOption.GROUP_BY_CATEGORY}
      actionButtonText={t('topicOverview:planTopic')}
      actionButtonOnClick={(tg) => {
        createSurveyPath.toFunc(tg.id!, tg.name);
      }}
      requireValidForAction={true}
      filterTopicGroups={(topicGroup) => !topicGroup.containsSteps && isPulserTopicGroup(topicGroup)}
    />
  );
};

export default PulserConversationSubjectsScreen;
